/**
 * Combine the parent and child layer data.
 */

import clone from 'lodash/clone'
import get from 'lodash/get'
import toLower from 'lodash/toLower'

export default function (currentTarget, str) {
  let strCopy = clone(str)
  const propertiesAll = get(currentTarget, 'propertiesAll', [])
  for (const key in propertiesAll) {
    if (key && key !== '') {
      const searchStr = '[' + toLower(key) + ']'
      const replaceStr = propertiesAll[key]
      strCopy = strCopy.split(searchStr).join(replaceStr)
      // Also try to replace without toLower
      const searchStrNotToLower = '[' + key + ']'
      const replaceStrNotToLower = propertiesAll[key]
      strCopy = strCopy.split(searchStrNotToLower).join(replaceStrNotToLower)
    }
  }
  return strCopy
}
